"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get isAdminTierForReportType () {
        return isAdminTierForReportType;
    },
    get wasCreatedByNonAdmin () {
        return wasCreatedByNonAdmin;
    }
});
// Literals, not the enum: the React app and the reporting server each have their own copy.
const CREATE_REPORT = "report_analytics:createReport";
const CREATE_EMPLOYEE_REPORT = "report_analytics:createEmployeeReport";
const EMPLOYEE_REPORT_TYPE = "employeeReport";
const ADMIN_CREATOR_ROLE = "admin";
const isAdminTierForReportType = (userPermissions, reportType)=>Boolean(userPermissions?.includes(CREATE_REPORT) || userPermissions?.includes(CREATE_EMPLOYEE_REPORT) && reportType === EMPLOYEE_REPORT_TYPE);
const wasCreatedByNonAdmin = (createdByRoles)=>Boolean(createdByRoles?.length) && !createdByRoles?.includes(ADMIN_CREATOR_ROLE);
